import { ApplicationEvent, } from '@standardnotes/snjs';
import { makeObservable, observable, action, runInAction, computed } from 'mobx';
import { AbstractViewController } from './Abstract/AbstractViewController';
export class SearchOptionsController extends AbstractViewController {
    constructor(protections, eventBus) {
        super(eventBus);
        this.protections = protections;
        this.includeProtectedContents = false;
        this.includeArchived = false;
        this.includeTrashed = false;
        this.noteTitleOnly = false;
        this.tagFilterList = [];
        this.toggleIncludeArchived = () => {
            this.includeArchived = !this.includeArchived;
        };
        this.toggleIncludeTrashed = () => {
            this.includeTrashed = !this.includeTrashed;
        };
        this.refreshIncludeProtectedContents = () => {
            this.includeProtectedContents = this.protections.hasUnprotectedAccessSession();
        };
        this.toggleIncludeProtectedContents = async () => {
            if (this.includeProtectedContents) {
                this.includeProtectedContents = false;
            }
            else {
                await this.protections.authorizeSearchingProtectedNotesText();
                runInAction(() => {
                    this.refreshIncludeProtectedContents();
                });
            }
        };
        this.setNoteTitleOnly = (value) => {
            this.noteTitleOnly = value;
        };
        this.addTagFilter = (tag) => {
            if (!this.tagFilterList.some((existing) => existing.uuid === tag.uuid)) {
                this.tagFilterList = [...this.tagFilterList, tag];
            }
        };
        this.removeTagFilter = (tag) => {
            this.tagFilterList = this.tagFilterList.filter((existing) => existing.uuid !== tag.uuid);
        };
        this.clearTagFilters = () => {
            this.tagFilterList = [];
        };
        this.clearAllFilters = () => {
            this.noteTitleOnly = false;
            this.includeArchived = false;
            this.includeTrashed = false;
            this.includeProtectedContents = false;
            this.tagFilterList = [];
        };
        makeObservable(this, {
            includeProtectedContents: observable,
            includeTrashed: observable,
            includeArchived: observable,
            noteTitleOnly: observable,
            tagFilterList: observable,
            toggleIncludeArchived: action,
            toggleIncludeTrashed: action,
            toggleIncludeProtectedContents: action,
            refreshIncludeProtectedContents: action,
            setNoteTitleOnly: action,
            addTagFilter: action,
            removeTagFilter: action,
            clearTagFilters: action,
            clearAllFilters: action,
            activeSearchFilterCount: computed,
        });
        eventBus.addEventHandler(this, ApplicationEvent.UnprotectedSessionBegan);
        eventBus.addEventHandler(this, ApplicationEvent.UnprotectedSessionExpired);
    }
    async handleEvent(event) {
        if (event.type === ApplicationEvent.UnprotectedSessionBegan) {
            this.refreshIncludeProtectedContents();
        }
        else if (event.type === ApplicationEvent.UnprotectedSessionExpired) {
            this.refreshIncludeProtectedContents();
        }
    }
    get activeSearchFilterCount() {
        return (Number(this.noteTitleOnly) +
            Number(this.includeProtectedContents) +
            Number(this.includeArchived) +
            Number(this.includeTrashed) +
            this.tagFilterList.length);
    }
}
